var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav-bar'),_c('cover'),_c('overlay'),_c('statistics'),_c('programma'),_c('oweeprogramma'),_c('volleybal'),_c('vereniging'),_c('f-a-q'),_c('intresselijst'),_c('video-embedded'),_c('sponsors'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }